import React, { ComponentProps } from 'react';
import Type from 'components/Type';

const SectionHeadline = (props: ComponentProps<typeof Type.H2>) => (
  <Type.H2 variant="brio" {...props} />
);

export default SectionHeadline;
